/**
 * Payment types for bill generation.
 *
 * options: product, job, service, other.
 */
const paymentsTypes = [
    {
        value: 'payment',
        label: 'Платёж',
    },
    {
        value: 'service',
        label: 'Услуга',
    },
    {
        value: 'job',
        label: 'Работа',
    },
    {
        value: 'commodity',
        label: 'Товар',
    },
    {
        value: 'another',
        label: 'Другое',
    },
];

/**
 * Amount of payments in subscription.
 *
 * Options: inf
 */
const paymentsCounts = [
    {
        value: 'inf',
        label: 'Неограничего',
    },
    {
        value: 'specified',
        label: 'Как определено',
    },
];

/**
 * Subscription payments period.
 *
 * Don't forget to add paymentPeriods locales to src/utils/constants.js
 */
const paymentsPeriods = [
    {
        value: 1,
        label: 'Раз в день',
    },
    {
        value: 7,
        label: 'Раз в неделю',
    },
    {
        value: 14,
        label: 'Раз в две недели',
    },
    {
        value: 28,
        label: 'Раз в 4 недели',
    },
    {
        value: 30,
        label: 'Раз в месяц',
    },
    {
        value: 60,
        label: 'Раз в 2 месяца',
    },
    {
        value: 90,
        label: 'Раз в 3 месяца',
    },
    {
        value: 180,
        label: 'Раз в 6 месяцев',
    },
    {
        value: 365,
        label: 'Раз в год',
    },
];

export { paymentsCounts, paymentsPeriods, paymentsTypes };
